import axios from 'axios';

import { CITAS } from '../actions/types';

import { setAlert } from './alert';
import { changeLoader } from './loader';

export const buscarCitas = (filtros) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify(filtros);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/citas/listar`, body, config);

        await dispatch({
            type: CITAS.BUSCAR,
            payload: res.data.eventos
        });
    } catch (error) {
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const buscarHorariosCita = (filtros) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify(filtros);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/citas/horarios_disponibles`, body, config);

        await dispatch({
            type: CITAS.BUSCAR_HORARIOS,
            payload: res.data.horarios_disponibles
        });
    } catch (error) {
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const buscarContrataciones = (filtros) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify(filtros);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/citas/contrataciones`, body, config);

        await dispatch({
            type: CITAS.BUSCAR_CONTRATACIONES,
            payload: res.data.contrataciones_disponibles
        });
    } catch (error) {
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const crearCita = (cita) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify(cita);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/citas/crear`, body, config);

        await dispatch({
            type: CITAS.AGREGAR,
            payload: [res.data.cita]
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error) {
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const obtenerCita = (id) => async dispatch => {
    if(id){
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        }

        const body = { id };

        try {
            await dispatch(changeLoader(true));
            const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/citas/detalles`, body, config);

            await dispatch({
                type: CITAS.DETALLES,
                payload: res.data.cita
            });
        } catch (error) {
            if(error?.response?.data?.msg) {
                await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
            }
        } finally {
            await dispatch(changeLoader(false));
        }
    } else {
        dispatch({
            type: CITAS.DETALLES,
            payload: null
        });
    }
}

export const editarCita = (cita) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify(cita);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/citas/editar`, body, config);

        await dispatch({
            type: CITAS.EDITAR,
            payload: res.data.cita
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error) {
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const statusCita = (status) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify(status);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/citas/status`, body, config);

        await dispatch({
            type: CITAS.EDITAR,
            payload: res.data.cita
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error) {
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const eliminarCita = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = { id };

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/citas/eliminar`, body, config);

        await dispatch({
            type: CITAS.ELIMINAR,
            payload: [body.id]
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error) {
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const filtarCitas = (opcion) => dispatch => {
    dispatch({
        type: CITAS.FILTROS,
        payload: opcion
    });
}

export const buscarLocatarios = () => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    try {
        await dispatch(changeLoader(true));
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/citas/locatarios`, config);

        await dispatch({
            type: CITAS.BUSCAR_LOCATARIOS,
            payload: res.data.locatarios
        });
    } catch (error) {
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}
